/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const splitInventoryRowDataRequestSchema = z.object({
	quantity: z.number(),
	valueCents: z.number(),
	description: z.string().nullable().optional(),
})

export type SplitInventoryRowDataRequestSchema = z.infer<typeof splitInventoryRowDataRequestSchema>
